import * as api from "../Services/api";
import Client from "../../objs/Client";
import ClientSchool from "../../objs/ClientSchool";
import GapInService from "../../objs/GapInService";
import ReportAssignmentFileDetails from "../../objs/ReportAssignmentFileDetails";
import InPersonLog from "../../objs/InPersonLog";
import ServiceCoordinationNote from "../../objs/ServiceCoordinationNote";
import SessionNote from "../../objs/SessionNote";
import File from "../../objs/File";
import CaseNote from "../../objs/CaseNote";
import ClientDashboard from "../../objs/ClientDashboard";
import * as hub from "../Hubs/clientDashboardHub.js";

export const state = {
  clients: [],
  selectedClient: null,
  gapsInService: [],
  reportAssignments: [],
  documents: [],
  inPersonLogs: [],
  serviceCoordinationNotes: [],
  sessionNotes: [],
  clientDashboard: null,
};
export const getters = {};
export const mutations = {
  SET_CLIENTS(state, payload) {
    state.clients = payload ? payload.map((item) => new Client(item)) : [];
  },
  SET_SELECTED_CLIENT(state, payload) {
    state.selectedClient = payload ? new Client(payload) : null;
  },
  CLEAR_CLIENT(state) {
    state.selectedClient = null;
    state.gapsInService = null;
    state.documents = null;
    state.reportAssignments = null;
    state.sessionNotes = null;
    state.serviceCoordinationNotes = null;
    state.inPersonLogs = null;
  },
  ADD_CLIENT(state, payload) {
    state.clients.push(new Client(payload));
  },
  UPDATE_CLIENT(state, payload) {
    state.clients = state.clients.map((item) => {
      return item.clientId == payload.clientId ? new Client(payload) : item;
    });
  },
  ADD_CLIENT_SCHOOL(state, payload) {
    state.selectedClient.clientSchools.push(new ClientSchool(payload));
  },
  UPDATE_CLIENT_SCHOOL(state, payload) {
    state.selectedClient.clientSchools = state.selectedClient.clientSchools.map(
      (item) => {
        return item.clientSchoolId == payload.clientSchoolId
          ? new ClientSchool(payload)
          : item;
      }
    );
  },
  SET_CLIENT_CHART(state, payload) {
    state.documents = payload.documents
      ? payload.documents.map((item) => new File(item))
      : [];
    state.inPersonLogs = payload.inPersonLogs
      ? payload.inPersonLogs.map((item) => new InPersonLog(item))
      : [];
    state.reportAssignments = payload.reportAssignments
      ? payload.reportAssignments.map(
          (item) => new ReportAssignmentFileDetails(item)
        )
      : [];
    state.gapsInService = payload.gapsInService
      ? payload.gapsInService.map((item) => new GapInService(item))
      : [];
    state.serviceCoordinationNotes = payload.serviceCoordinationNotes
      ? payload.serviceCoordinationNotes.map(
          (item) => new ServiceCoordinationNote(item)
        )
      : [];
    state.sessionNotes = payload.sessionNotes
      ? payload.sessionNotes.map((item) => new SessionNote(item))
      : [];
  },
  SET_SESSION_NOTES(state, payload) {
    state.sessionNotes = payload
      ? payload.map((item) => new SessionNote(item))
      : [];
  },
  SET_SERVICE_COORDINATION_NOTES(state, payload) {
    state.serviceCoordinationNotes = payload
      ? payload.map((item) => new ServiceCoordinationNote(item))
      : [];
  },
  SET_GAPS_IN_SERVICE(state, payload) {
    state.gapsInService = payload
      ? payload.map((item) => new GapInService(item))
      : [];
  },
  SET_DOCUMENTS(state, payload) {
    state.documents = payload ? payload.map((item) => new File(item)) : [];
  },
  ADD_DOCUMENTS(state, payload) {
    state.documents.push(...payload.map((item) => new File(item)));
  },
  UPDATE_DOCUMENT(state, payload) {
    var index = state.documents.findIndex(
      (item) => item.fileId == payload.fileId
    );
    state.documents.splice(index, 1, new File(payload));
  },
  DELETE_DOCUMENT(state, fileId) {
    var index = state.documents.findIndex((item) => item.fileId == fileId);
    state.documents.splice(index, 1);
  },
  ADD_CASE_NOTE(state, payload) {
    state.selectedClient.caseNotes.push(new CaseNote(payload));
  },
  UPDATE_CASE_NOTE(state, payload) {
    var index = state.selectedClient.caseNotes.findIndex(
      (item) => item.caseNoteId == payload.caseNoteId
    );
    state.selectedClient.caseNotes.splice(index, 1, new CaseNote(payload));
  },
  DELETE_CASE_NOTE(state, caseNoteId) {
    var index = state.selectedClient.caseNotes.findIndex(
      (item) => item.caseNoteId == caseNoteId
    );
    state.selectedClient.caseNotes.splice(index, 1);
  },
  UPDATE_SC_SIGNATURE(state, payload) {
    var index = state.serviceCoordinationNotes.findIndex(
      (item) =>
        item.serviceCoordinationNoteId == payload.serviceCoordinationNoteId
    );
    state.serviceCoordinationNotes.splice(
      index,
      1,
      new ServiceCoordinationNote(payload)
    );
  },
  UPDATE_SESSION_NOTE_SIGNATURE(state, payload) {
    var index = state.sessionNotes.findIndex(
      (item) => item.sessionNoteId == payload.sessionNoteId
    );
    state.sessionNotes.splice(index, 1, new SessionNote(payload));
  },
  UPDATE_GAPS_IN_SERVICE(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      const findIndex = state.gapsInService.findIndex(
        ({ gapInServiceId }) => gapInServiceId === payload[i].gapInServiceId
      );
      state.gapsInService.splice(findIndex, 1, new GapInService(payload[i]));
    }
  },
  SET_CLIENT_DASHBOARD(state, payload) {
    if (state.selectedClient.clientId == payload.clientId) {
      state.clientDashboard = payload
        ? new ClientDashboard(payload)
        : null;
    }
  },
  CLEAR_CLIENT_DASHBOARD(state) {
    state.clientDashboard = null;
  },
};
export const actions = {
  async getClient({ commit }, data) {
    return api
      .getQuery("/client/getClient", {
        clientId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("SET_SELECTED_CLIENT", response.data);
        }
        return response.success;
      });
  },
  async importClient({ commit }, data) {
    return await api
      .postQuery("/boeImport/importSingleClient", data)
      .then((response) => {
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async searchClients({ commit }, data) {
    return await api.post("/client/searchClients", data).then((response) => {
      if (response.success) {
        commit("SET_CLIENTS", response.data);
      }
      return response.success;
    });
  },
  async searchClientsForProvider({ commit, rootState, dispatch }, data) {
    let providerId = rootState.sharedModule.providerId;
    if (!providerId) {
      providerId = await dispatch("sharedModule/getProviderId", null, {
        root: true,
      });
    }
    return await api
      .postQueryWithBody(
        "/client/searchClientsForProvider",
        { providerId: providerId },
        data
      )
      .then((response) => {
        if (response.success) {
          commit("SET_CLIENTS", response.data);
        }
        return response.success;
      });
  },
  clearClient({ commit }) {
    commit("CLEAR_CLIENT");
    commit("CLEAR_CLIENT_DASHBOARD");
  },
  async createClient({ commit }, data) {
    return await api.post("/client/createClient", data).then((response) => {
      if (response.success) {
        commit("ADD_CLIENT", response.data);
        commit("SET_SELECTED_CLIENT", response.data);
        return "";
      } else {
        return response.message;
      }
    });
  },
  async updateClient({ commit }, data) {
    return await api.post("/client/updateClient", data).then((response) => {
      if (response.success) {
        commit("UPDATE_CLIENT", response.data);
        commit("SET_SELECTED_CLIENT", response.data);
        return "";
      } else {
        return response.message;
      }
    });
  },
  async createClientSchool({ commit }, data) {
    return await api
      .post("/client/createClientSchool", data)
      .then((response) => {
        if (response.success) {
          commit("ADD_CLIENT_SCHOOL", response.data);
          return "";
        }
        return response.message;
      });
  },
  async updateClientSchool({ commit }, data) {
    return await api
      .post("/client/updateClientSchool", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_CLIENT_SCHOOL", response.data);
          return "";
        }
        return response.message;
      });
  },
  async getAllGapsInService({ commit }) {
    return api.getQuery("/sessionNote/getAllGapsInService").then((response) => {
      if (response.success) {
        commit("SET_GAPS_IN_SERVICE", response.data);
      }
      return response.success;
    });
  },
  async setGapsInServiceSentToSC({ commit }, data) {
    return api
      .post("/sessionNote/setGapsInServiceSentToSC", data.ids)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_GAPS_IN_SERVICE", response.data);
        }
        return response.success;
      });
  },
  async getClientChart({ commit }, data) {
    return api
      .getQuery("/sessionNote/GetClientChart", {
        clientId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("SET_CLIENT_CHART", response.data);
        }
        return response.success;
      });
  },
  async getClientChartAdmin({ commit }, data) {
    return api
      .getQuery("/sessionNote/GetClientChartAdmin", {
        clientId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("SET_CLIENT_CHART", response.data);
        }
        return response.success;
      });
  },
  async updateClientDocument({ commit }, data) {
    return api
      .postQuery("/client/updateClientDocument", {
        fileId: data.fileId,
        documentTypeId: data.documentTypeId,
        fileName: data.fileName,
      })
      .then((response) => {
        if (response.success) {
          commit("UPDATE_DOCUMENT", response.data);
        }
        return response.success;
      });
  },
  async deleteClientDocument({ commit }, data) {
    return api
      .postQuery("/client/deleteClientDocument", { fileId: data })
      .then((response) => {
        if (response.success) {
          commit("DELETE_DOCUMENT", data);
        }
        return response.success;
      });
  },
  async saveCaseNote({ commit }, data) {
    return await api
      .post("/client/createCaseNote", data)
      .then((response) => {
        if (response.success) {
          commit("ADD_CASE_NOTE", response.data);
        }

        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async updateCaseNote({ commit }, data) {
    return await api
      .post("/client/updateCaseNote", {
        ...data,
      })
      .then((response) => {
        if (response.success) {
          commit("UPDATE_CASE_NOTE", response.data);
        }

        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async deleteCaseNote({ commit }, data) {
    return await api
      .postQuery("/client/deleteCaseNote", data)
      .then((response) => {
        if (response.success) {
          commit("DELETE_CASE_NOTE", data.caseNoteId);
          return "";
        }

        return response.message;
      })
      .catch((error) => {
        return false;
      });
  },
  async uploadFilesForClient({ commit }, data) {
    return await api
      .uploadFiles(
        "/client/uploadFilesForClient",
        { clientId: data.clientId, documentTypeId: data.documentTypeId },
        data
      )
      .then((response) => {
        if (response.success) {
          commit("ADD_DOCUMENTS", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async searchFiles({ commit }, data) {
    return await api
      .getQuery("/files/searchFiles", { fileName: data.fileName })
      .then((response) => {
        if (response.success) {
          commit("SET_DOCUMENTS", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async getSCNotesForProvider({ commit }, data) {
    return await api
      .getQuery("/sessionNote/getSCNotesForProvider", data)
      .then((response) => {
        if (response.success) {
          commit("SET_SERVICE_COORDINATION_NOTES", response.data);
        }
        return response;
      })
      .catch((error) => {
        return false;
      });
  },
  async findSessionNotes({ commit }, data) {
    return await api
      .getQuery("/sessionNote/findSessionNotes", data)
      .then((response) => {
        if (response.success) {
          commit(
            "SET_SERVICE_COORDINATION_NOTES",
            response.data.serviceCoordinationNotes
          );
          commit("SET_SESSION_NOTES", response.data.sessionNotes);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async signServiceCoordinationNote({ commit, state, rootState }, data) {
    const userSessionLogId =
      rootState.securityModule.userSessionLog.userSessionLogId || "";
    return await api
      .postQueryWithBody(
        "/SessionNote/SignServiceCoordinationNote",
        { serviceCoordinationNoteId: data.serviceCoordinationNoteId },
        {
          consentedAt: data.consentedAt,
          signatureURI: data.signatureURI,
          userSessionLogId: userSessionLogId,
        }
      )
      .then((response) => {
        if (response.success) {
          commit("UPDATE_SC_SIGNATURE", response.data);
        }
        return response;
      })
      .catch((error) => {
        return false;
      });
  },

  async signSessionNote({ commit, state, rootState }, data) {
    const userSessionLogId =
      rootState.securityModule.userSessionLog.userSessionLogId || "";
    return await api
      .postQueryWithBody(
        "/SessionNote/SignSessionNote",
        { sessionNoteId: data.sessionNoteId },
        {
          consentedAt: data.consentedAt,
          signatureURI: data.signatureURI,
          userSessionLogId: userSessionLogId,
        }
      )
      .then((response) => {
        if (response.success) {
          commit("UPDATE_SESSION_NOTE_SIGNATURE", response.data);
        }
        return response;
      })
      .catch((error) => {
        return false;
      });
  },
  async getClientDashboard({ commit }, data) {
    return api
      .getQuery("/client/GetClientDashboard", {
        clientId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("SET_CLIENT_DASHBOARD", response.data);
        }
        return response.success;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
